import { fetchParseProductImages } from "@apis/http/api";
import { useMemoizedFn } from "ahooks";
import { message } from "antd";
import { useTranslation } from "react-i18next";

export function useGetProductInfo() {
  const { t } = useTranslation();
  return useMemoizedFn(async (obj: { id: string; country?: string }) => {
    const parsed = await fetchParseProductImages({ id: obj.id, country: obj.country || "US" });
    if (!parsed || !parsed.product) {
      message.error(t("Something went wrong. Please try again."));
      return undefined;
    }
    return parsed;
  });
}
